// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/icons/globe-base.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
} */

/* body {
  margin: 0;
  font-family: 'Segoe UI', sans-serif;
  background: url('../public/icons/bg.png') no-repeat center center fixed;
  background-size: cover;
  height: 100vh;
}

  


/* Existing App-specific styles */

body {
  margin: 0;
  font-family: 'Segoe UI', sans-serif;

  background-size: cover;
  height: 100vh;
} 
.video-background {
  position: fixed;  /* Fixed positioning ensures video stays in place while scrolling */
  top: 0;
  left: 0;
  width: 100vw;  /* Full viewport width */
  height: 100vh;  /* Full viewport height */
  object-fit: cover;  /* Ensure the video covers the screen without stretching */
  z-index: -1;  /* Video stays behind other content */
  pointer-events: none;  /* Prevent interaction with the video */
}

/* App container ensuring content stays on top of the video */
.app {
align-items: center;

}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Override the Dark Hawk Menu with Background */
/* Container for DARKHAWK */
.darkhawk-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});  /* Reference the image from the public folder */
  background-size: cover;  /* Ensure the image covers the entire container */
  background-position: center center;  /* Position the background image */
  display: flex;
  align-items: center;  /* Center content vertically */
  justify-content: center;
  overflow: hidden;  /* Prevent horizontal overflow */
  /* Set the thumb (scrollbar) color to dark navy and track color to black */
}

/* Scrollbar styling for Webkit browsers */
.darkhawk-container::-webkit-scrollbar {
  width: 8px;  /* Set the width of the scrollbar */
}

.darkhawk-container::-webkit-scrollbar-thumb {
  background-color: #1a1a2e;  /* Dark navy color for the scrollbar thumb */
  border-radius: 10px;  /* Rounded corners for the scrollbar thumb */
}

.darkhawk-container::-webkit-scrollbar-track {
  background-color: #121212;  /* Dark background for the scrollbar track */
}

/* iFrame Styling */
.darkhawk-container iframe {
  width: 95vw;        /* Full width */
  height: 112vh;      /* Full height */
  border: none;       /* No border around the iframe */
  position: relative; /* Make it movable */
  left: 0%;          
  transform: translateX(9%);  /* Moves the iframe slightly to the right */
  zoom: 89%;  /* Zoom out */

}

/* Handling the error page for iframe */
#sub-frame-error {
  display: none;  /* Hide error message, as we want to show the iframe */
}

#sub-frame-error-details {
  display: none;  /* Hide details of the error */
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqCG;;AAEH;;;;;;;;;;;iCAWiC;;AAEjC;EACE,SAAS;EACT,mCAAmC;;EAEnC,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,eAAe,GAAG,mEAAmE;EACrF,MAAM;EACN,OAAO;EACP,YAAY,GAAG,wBAAwB;EACvC,aAAa,GAAG,yBAAyB;EACzC,iBAAiB,GAAG,0DAA0D;EAC9E,WAAW,GAAG,qCAAqC;EACnD,oBAAoB,GAAG,uCAAuC;AAChE;;AAEA,6DAA6D;AAC7D;AACA,mBAAmB;;AAEnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gDAAgD;AAChD,2BAA2B;AAC3B;EACE,yDAAuD,GAAG,+CAA+C;EACzG,sBAAsB,GAAG,iDAAiD;EAC1E,kCAAkC,GAAG,kCAAkC;EACvE,aAAa;EACb,mBAAmB,GAAG,8BAA8B;EACpD,uBAAuB;EACvB,gBAAgB,GAAG,gCAAgC;EACnD,0EAA0E;AAC5E;;AAEA,0CAA0C;AAC1C;EACE,UAAU,GAAG,mCAAmC;AAClD;;AAEA;EACE,yBAAyB,GAAG,4CAA4C;EACxE,mBAAmB,GAAG,4CAA4C;AACpE;;AAEA;EACE,yBAAyB,GAAG,4CAA4C;AAC1E;;AAEA,mBAAmB;AACnB;EACE,WAAW,SAAS,eAAe;EACnC,aAAa,OAAO,gBAAgB;EACpC,YAAY,QAAQ,gCAAgC;EACpD,kBAAkB,EAAE,oBAAoB;EACxC,QAAQ;EACR,yBAAyB,GAAG,2CAA2C;EACvE,SAAS,GAAG,aAAa;;AAE3B;;AAEA,uCAAuC;AACvC;EACE,aAAa,GAAG,sDAAsD;AACxE;;AAEA;EACE,aAAa,GAAG,8BAA8B;AAChD","sourcesContent":["/* .App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n} */\n\n/* body {\n  margin: 0;\n  font-family: 'Segoe UI', sans-serif;\n  background: url('../public/icons/bg.png') no-repeat center center fixed;\n  background-size: cover;\n  height: 100vh;\n}\n\n  \n\n\n/* Existing App-specific styles */\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', sans-serif;\n\n  background-size: cover;\n  height: 100vh;\n} \n.video-background {\n  position: fixed;  /* Fixed positioning ensures video stays in place while scrolling */\n  top: 0;\n  left: 0;\n  width: 100vw;  /* Full viewport width */\n  height: 100vh;  /* Full viewport height */\n  object-fit: cover;  /* Ensure the video covers the screen without stretching */\n  z-index: -1;  /* Video stays behind other content */\n  pointer-events: none;  /* Prevent interaction with the video */\n}\n\n/* App container ensuring content stays on top of the video */\n.app {\nalign-items: center;\n\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Override the Dark Hawk Menu with Background */\n/* Container for DARKHAWK */\n.darkhawk-container {\n  background-image: url(\"../public/icons/globe-base.png\");  /* Reference the image from the public folder */\n  background-size: cover;  /* Ensure the image covers the entire container */\n  background-position: center center;  /* Position the background image */\n  display: flex;\n  align-items: center;  /* Center content vertically */\n  justify-content: center;\n  overflow: hidden;  /* Prevent horizontal overflow */\n  /* Set the thumb (scrollbar) color to dark navy and track color to black */\n}\n\n/* Scrollbar styling for Webkit browsers */\n.darkhawk-container::-webkit-scrollbar {\n  width: 8px;  /* Set the width of the scrollbar */\n}\n\n.darkhawk-container::-webkit-scrollbar-thumb {\n  background-color: #1a1a2e;  /* Dark navy color for the scrollbar thumb */\n  border-radius: 10px;  /* Rounded corners for the scrollbar thumb */\n}\n\n.darkhawk-container::-webkit-scrollbar-track {\n  background-color: #121212;  /* Dark background for the scrollbar track */\n}\n\n/* iFrame Styling */\n.darkhawk-container iframe {\n  width: 95vw;        /* Full width */\n  height: 112vh;      /* Full height */\n  border: none;       /* No border around the iframe */\n  position: relative; /* Make it movable */\n  left: 0%;          \n  transform: translateX(9%);  /* Moves the iframe slightly to the right */\n  zoom: 89%;  /* Zoom out */\n\n}\n\n/* Handling the error page for iframe */\n#sub-frame-error {\n  display: none;  /* Hide error message, as we want to show the iframe */\n}\n\n#sub-frame-error-details {\n  display: none;  /* Hide details of the error */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
